import {useMemo} from "react";
import {useSelector} from "react-redux";
import _ from "lodash";
import {buildCustomFields, isCustomFieldSupported} from "../CustomFieldUtils";

export default function () {
    let customFieldList = useSelector(state => state.customField.messageCustomFields);
    customFieldList = _.get(customFieldList, 'customFields') || [];
    const loadingCustomFields = useSelector(state => state.customField.listMessageCustomFieldsLoading);
    const originalConversation = useSelector(state => state.fullEmailConversation.emailConversationData);
    const conversationCustomFields = _.get(originalConversation, 'emailConversation.0.customFields') || [];
    const loadingOriginalConversation = useSelector(state => state.fullEmailConversation.loadingEmailConversation);
    const message = useSelector(state => state.messages.nextMessage);
    const loadingNextMessage = useSelector(state => state.messages.loadingNextMessage);
    const loading = loadingOriginalConversation || loadingCustomFields || loadingNextMessage;

    const hasCustomFields =
        !_.isEmpty(customFieldList) &&
        !_.isEmpty(conversationCustomFields) &&
        !loadingCustomFields &&
        !loadingOriginalConversation;

    const sourceName = _.toString(_.get(message, 'sourceName')).toLowerCase();
    const isSupported = isCustomFieldSupported(sourceName);
    const shouldProcess = isSupported && hasCustomFields;

    const customFields = useMemo(() => {
        if(!shouldProcess) {
            return [];
        }
        return buildCustomFields(customFieldList, conversationCustomFields);

    }, [loading, _.get(originalConversation, 'messageId')]) || [];

    return { customFields, loadingCustomFields };
}